import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '@mhub/web-components';

import AppHeader from '../../components/AppHeader';
import './styles.css';

const NotFound = () => (
  <Container className="NotFound" noContent>
    <AppHeader header="Page not found!" />
    <Button
      as={Link}
      color="blue"
      ripple
      to="/"
      replace
    >
      Back
    </Button>
  </Container>
);

export default NotFound;
